import React, {useEffect, useState} from "react";
import {Competition} from "../../../../../types/eventTypes";
import {Box, FormControl} from "@mui/material";
import MatchSearch from "../../../CommonComponents/SearchAutocomplete/MatchSearch";
import CustomAutoComplete from "../../../CommonComponents/CustomAutoComplete";
import {getCompetitionOptions} from "../../../../../queries/competitionQueries";
import {ActiveFilters, FilterOption} from "@/types/filterTypes";
import {CONTENT_PRESET_LABEL} from "@/constants/globalConstants";
import {useContentSpecificParams} from "@/contexts/ContentSpecificParamsContext";
import {useSelectedCard} from "@/contexts/SelectedCardContext";
import {PANEL_MODE} from "@/types/generic";

interface MatchHighlightFiltersProps {
    competition: FilterOption,
    event: FilterOption | null
    onCompetitionChange: (Competition: FilterOption) => void;
    onEventChange: (event: FilterOption | null) => void;
    disabled?: boolean;
    presetMode?: boolean
}

const DEFAULT_APP_COMPETITION_NAME = (import.meta as any).env.VITE_CONTENT_CREATION_COMPETITION_NAME
const DEFAULT_APP_COMPETITION_SEASON = (import.meta as any).env.VITE_CONTENT_CREATION_COMPETITION_SEASON

const MatchHighlightFilters: React.FC<MatchHighlightFiltersProps> = ({event, competition, onEventChange, onCompetitionChange, disabled = false, presetMode = false}) => {
    const [competitions, setCompetitions] = useState<Competition[]>([]);
    const [matchFilters, setMatchFilters] = useState<ActiveFilters | undefined>();
    const { contentSpecificParams } = useContentSpecificParams();
    const { panelMode } = useSelectedCard()

    const loadCompetitionsOptions = async () => {
        const tempCompetitions = await getCompetitionOptions()
        setCompetitions(tempCompetitions);
        const defaultCompetition = tempCompetitions.find(comp => {
            return comp.value.toLowerCase().includes(DEFAULT_APP_COMPETITION_NAME) && comp.value.toLowerCase().includes(DEFAULT_APP_COMPETITION_SEASON)
        })
        if (panelMode === PANEL_MODE.CREATE){
            handleCompetitionChange(contentSpecificParams.competition || defaultCompetition || tempCompetitions[0] || null)
        }
    }

    const handleCompetitionChange = (competition: FilterOption | null) => {
        if (competition === null){
            setMatchFilters(undefined)
        }else{
            setMatchFilters({competitionFilterValues: [competition]})
        }
        onCompetitionChange(competition)
    }

    useEffect(() => {
        if (competition === null){
            setMatchFilters(undefined)
        }else{
            setMatchFilters({competitionFilterValues: [competition]})
        }
    }, [competition]);

    useEffect(() => {
        if(!presetMode){
            loadCompetitionsOptions()
        }else{
            onCompetitionChange({id: CONTENT_PRESET_LABEL, value: CONTENT_PRESET_LABEL})
            onEventChange({id: CONTENT_PRESET_LABEL, value: CONTENT_PRESET_LABEL})
        }
    }, []);

    return(
        <Box display={'flex'} flexDirection={'column'} gap={2}>
            <FormControl fullWidth>
                <CustomAutoComplete
                    label={"Competition"}
                    options={competitions}
                    value={competition}
                    onChange={(_: any, newValue: any) => handleCompetitionChange(newValue)}
                    customAutocomplete={false}
                    multiple={false}
                    labelField={'value'}
                    valueField={'id'}
                    //disabled={(disabled || presetMode)}
                    readOnly={(disabled || presetMode)}
                />
            </FormControl>
            <FormControl fullWidth>
                <MatchSearch
                    label={'Match'}
                    value={event}
                    onChange={onEventChange}
                    freeSolo={false}
                    additionalFilters={matchFilters}
                    //disabled={(disabled || presetMode)}
                    readOnly={(disabled || presetMode)}
                />
            </FormControl>
        </Box>

    )
}

export default MatchHighlightFilters;
